import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

export const OfferInsuranceSummary = ({ insurance, t }) => {
  const renderSelectedInsuranceCompany = () => (
    <Grid container spacing={1}>
      {insurance.company && (
        <Grid item xs={12}>
          {t('OfferEdit.Insurance.Company')} : <span>{insurance.company.name}</span>
        </Grid>
      )}
    </Grid>
  );

  const renderHisOwnInsurance = () => (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <span>{t('OfferEdit.Insurance.HisOwnInsurance')}</span>
      </Grid>
    </Grid>
  );

  return <>{insurance.hisOwnInsurance ? renderHisOwnInsurance() : renderSelectedInsuranceCompany()}</>;
};

OfferInsuranceSummary.propTypes = {
  insurance: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(OfferInsuranceSummary);
